/**
 * Syncs user and outfitter context to Sentry scope so all events/spans carry
 * user_id, user.is_admin, and outfitter_id. Mount inside UserProvider and
 * PortalEntitiesProvider (e.g. in wrap-root-element).
 */

import type { ReactNode } from "react"

import { useOutfitterContext } from "~contexts/outfitter-provider"
import { useUser } from "~contexts/user-provider"
import { useSentryScopeSync } from "~utils/sentry"

export default function SentryScopeSync({
    children,
}: {
    readonly children: ReactNode
}) {
    const { user, isAdmin } = useUser()
    const { outfitterId } = useOutfitterContext()

    useSentryScopeSync({
        userId: user?.id ?? null,
        isAdmin,
        outfitterId: outfitterId ?? null,
    })

    return children
}
